'use strict';

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./cjs/react-hotkeys.production.min.js');
} else {
  module.exports = require('./cjs/index.js');
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-hotkeys/index.js
 ** module id = 577
 ** module chunks = 0
 **/